import IconBadge from './IconBadge'

export * from './IconBadge'

export default IconBadge
